import { P } from '@dnb/eufemia';
import { groupBy } from '@portals/shared-frontend/utils';

import { AccessGrid } from '../AccessGrid';

type ScopeListProps = {
  scopes: { name: string; environment: string }[];
};

export function ScopeAccess({ scopes }: ScopeListProps) {
  const scopeAccesses = groupBy(scopes, 'name');

  const rows = Object.entries(scopeAccesses).map(([scopeName, access]) => ({
    label: <P>{scopeName}</P>,
    hasTestAccess: access.some((val) => val.environment === 'TEST'),
    hasLiveAccess: access.some((val) => val.environment === 'LIVE'),
  }));

  return <AccessGrid rows={rows} />;
}
